import { render, staticRenderFns } from "./SearchMusicTagsFilter.vue?vue&type=template&id=adc4541c&scoped=true&"
import script from "./SearchMusicTagsFilter.vue?vue&type=script&lang=js&"
export * from "./SearchMusicTagsFilter.vue?vue&type=script&lang=js&"
import style0 from "./SearchMusicTagsFilter.vue?vue&type=style&index=0&id=adc4541c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc4541c",
  null
  
)

export default component.exports